module.exports = __webpack_public_path__ + "assets/img/redback.368cf718.png";